// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"994c4282","100":"3d8be6f1","165":"e6137fbe","370":"0f8de19a","494":"79c55777","551":"11d492fd","656":"6ce2f76f"}[chunkId] + ".chunk.js";
};